import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;

  .MuiFormGroup-root {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4px;
  }

  .MuiFormControlLabel-root {
    margin: 0;
  }
`;
